import { render, staticRenderFns } from "./IconBetaLeads.vue?vue&type=template&id=71672784&"
import script from "./IconBetaLeads.vue?vue&type=script&lang=ts&"
export * from "./IconBetaLeads.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports